module.exports = __webpack_public_path__ + "static/media/opscore-logo.b47fceae.svg";